module.exports = __webpack_public_path__ + "img/fire.15c4b778.gif";